"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.filterOmegaProps = exports.getOmegaEvent = exports.sendOmegaEvent = exports.trackOmega = void 0;
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
var trackOmega_1 = require("./trackOmega");
Object.defineProperty(exports, "trackOmega", { enumerable: true, get: function () { return trackOmega_1.trackOmega; } });
var sendOmegaEvent_1 = require("./sendOmegaEvent");
Object.defineProperty(exports, "sendOmegaEvent", { enumerable: true, get: function () { return sendOmegaEvent_1.sendOmegaEvent; } });
/**
 * Generates an object of omega event data.
 * @param data Omega event data.
 * @param data.attributes Optional list of attributes.
 * @param data.element The name or label of the element acted upon.
 * @param data.event The event.
 * @param data.feature The feature.
 * @param data.search Optional search.
 * @param data.type The type.
 * @param data.widget The widget, a subset of the feature.
 * @returns Correctly formatted object of event information.
 */
function getOmegaEvent(_a) {
    var action = _a.action, attributes = _a.attributes, element = _a.element, event = _a.event, feature = _a.feature, search = _a.search, type = _a.type, widget = _a.widget;
    action = action || event && event.type;
    type = type || event && event.target && event.target.nodeName.toLowerCase();
    feature = feature || 'shell header';
    widget = widget || { name: element, type: type };
    var eventData = { action: action, attributes: attributes, element: element, feature: feature, search: search, type: type, widget: widget };
    if (!eventData.attributes) {
        delete eventData.attributes;
    }
    if (!eventData.search) {
        delete eventData.search;
    }
    return eventData;
}
exports.getOmegaEvent = getOmegaEvent;
/**
 * Filter props to only include specific Omega properties. This function is only used
 * in cases where users want to pass data-omega-feature, data-omega-widget and
 * data-omega-widget-type to override the default omega attributes added by Quarry or
 * other components having default omega attributes. It can also be used to filter
 * default omega props passed to components, or to pass other attributes such as
 * data-omega-attribute-* and data-omega-action. This function does not retain
 * the element and action omega attributes as they do not support default values.
 * @param props - An object containing any props.
 * @returns An object containing only the props that have Omega properties.
 */
var filterOmegaProps = function (props) {
    var omegaProps = {};
    Object.entries(props).forEach(function (_a) {
        var key = _a[0], value = _a[1];
        if ([
            'data-omega-feature',
            'data-omega-feature-default',
            'data-omega-widget',
            'data-omega-widget-default',
            'data-omega-widget-type',
            'data-omega-widget-type-default',
            'data-omega-action'
        ].includes(key) ||
            key.startsWith('data-omega-attribute-')) {
            omegaProps[key] = value;
        }
    });
    return omegaProps;
};
exports.filterOmegaProps = filterOmegaProps;
